import React, { PropsWithChildren } from "react"
import { Row, Col } from "react-grid-system"
import styled from "styled-components"
import PageContentWrapper from "../organisms/PageContentWrapper"

const Section = styled.div<{ bgColor?: string }>`
  background-color: ${(props) => props.bgColor ?? props.theme.colors.greyLighter};
  box-shadow: 0 0 4px 0 rgba(119, 119, 119, 0.25) inset;
  padding-block: 5rem;
`

const FormSection: React.FC<PropsWithChildren<{ bgColor?: string }>> = ({ children, bgColor }) => {
  return (
    <Section bgColor={bgColor}>
      <PageContentWrapper>
        <Row justify="center" align="center">
          <Col>{children}</Col>
        </Row>
      </PageContentWrapper>
    </Section>
  )
}

export default FormSection
